// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"style__logoContainer__34PDo","logos":"style__logos__Cy8GS"};